import { render, staticRenderFns } from "./TimelineOfficialExclude.vue?vue&type=template&id=20a84b6c&scoped=true"
import script from "./TimelineOfficialExclude.vue?vue&type=script&lang=js"
export * from "./TimelineOfficialExclude.vue?vue&type=script&lang=js"
import style0 from "./TimelineOfficialExclude.vue?vue&type=style&index=0&id=20a84b6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a84b6c",
  null
  
)

export default component.exports